import { color } from '@stockbit/ui';
import { StockPriceMovement } from './types';

export const stockPriceMovementColor = {
  [StockPriceMovement.Flat]: '#94B041',
  [StockPriceMovement.Down]: color.sunsetOrange,
  [StockPriceMovement.Up]: color.primary,
};

export const orderbookDataKey = {
  price: 'price',
  frequency: 'que_num',
  volume: 'volume',
};

export const bidOfferRowQuantity = 10;
